import {Component, OnInit} from '@angular/core';
import {AuthentificationService} from './authentification.service';
import {TransactionsService} from './transactions.service';
import {SortTable} from './sort-table.component';
import {Sort} from '@angular/material';
import {ActivatedRoute, Params} from '@angular/router';
import {AppComponent} from './app.component';
import {StocksService} from './stocks.service';

import {Router} from '@angular/router';
@Component({
    selector: 'app-enter-in-order-form-provider',
    templateUrl: './templates/out-in-order-from-out-of-ware.component.html',
    styleUrls: ['./styles/out-in-order-from-out-of-ware.component_news.css'],
    providers: [TransactionsService, AuthentificationService, SortTable, StocksService]
})
export class OutInOrderFromOutOfWare implements OnInit {

    session_mode: string = "RECEPTION";
    validate_list: Array<any>;
    id_transaction_detail: number = 0;
    validate_option: boolean = true;
    disable_edit_form: boolean = false;
    validate_bt: boolean = true;
    pannier_list: any;
    transaction_name: string = "";
    remark: string = "";
    disabled_input: boolean = true;
    sortedData: any = [];
    complete_infos: boolean = false;
    articles_list_popup: Array<any> = [];
    os_name: string = "";

    ngOnInit() {
        this.GetValidateOutofWareList();
    }

    constructor(private app_component: AppComponent,
        private transactions_service: TransactionsService,
        private router: Router,
        private authentification_service: AuthentificationService,
        private activated_route: ActivatedRoute,
        private sort_table: SortTable,
        private stock_service: StocksService
    ) {
        this.CheckUSerSession();
        this.app_component.valTest = '/out-from-out-of-ware';
        this.app_component.GetParent();
    }

    CheckUSerSession(): void {
        this.authentification_service.UserCheckSession().then(result => {if (result['id_user'] === 0) {this.router.navigate(['authentification'])} });
    }

    AddtoCart(purchase_id_transaction_d: any): void {
        this.validate_option = true;
        this.disable_edit_form = false;
        this.id_transaction_detail = purchase_id_transaction_d;
        this.transactions_service.GetOsDetails(purchase_id_transaction_d).then(result => {this.pannier_list = result['list']; this.os_name = result['name']; this.transaction_name = result['name']; this.remark = result['remark']; if (result['list'].length !== 0) {this.validate_bt = false} });
    }

    GetValidateOutofWareList(): void {
        this.transactions_service.GetValidateOutOfWareList().then(result => {
            this.GetTransactionDetails_cb(result['list']);
            this.sortedData = result['list'];
            this.sort_table.SetDataArray(
                result['list'],
                [{value: "transaction_name", type: ""}, {value: "applicant", type: ""}, {value: "timestamp", type: ""}]
            );
        });
    }

    Sort(sort: Sort): void {
        this.sort_table.sortData(sort);
        this.sortedData = this.sort_table.GetSortData();
    }

    RemoveFromPannierOutOfWareDetail(pannier: any): void {
        if (!this.disable_edit_form) {
            this.transactions_service.RemoveFromPannierOutOfWareDetail(pannier.id_article).then(pannier_list => {this.pannier_list = pannier_list['list']; if (pannier_list['list'].length === 0) {this.validate_bt = true} });
        }
    }

    LoadSessionPurchase() {
        this.transactions_service.GetSentOSOrderDetails().then(session_list => {this.pannier_list = session_list['list']; if (session_list['list'].length !== 0) {this.validate_bt = false} });
    }

    EditAndValidateModification(prod: any): void {
        if (!this.disable_edit_form) {
            if (prod.status === "RECEPTION") {
                this.EditArticleSessionPurchaseDetail(prod);
            } else if (prod.status === 'MODIFICATION') {
                this.ValidateEditArticleSessionPurchaseDetail(prod);
            }
        }
    }


    ValidateEditArticleSessionPurchaseDetail(prod: any): void {
        console.log(prod);
        if (isNaN(prod.qte_received)) {
            prod.qte_received = "Valeur invalide";
            setTimeout(() => {this.LoadSessionPurchase()}, 3500);
        }
        else {
            this.transactions_service.ValidateEditArticleSessionOSDetail(prod).then(result => {this.pannier_list = result['list']; this.SessionMod(result['list'])});
        }
    }

    EditArticleSessionPurchaseDetail(pannier: any): void {
     //   this.transactions_service.EditArticleSessionOSDetailBcf(pannier.id_article).then(result => {this.pannier_list = result['list']; this.disabled_input = false; this.SessionMod(result['list'])});
    }

//    ValidatePannierPurchaseDetail(): void {
//        this.transactions_service.ValidatePannierOutOfWareDetails(this.id_transaction_detail).then(result => {
//            this.pannier_list = [];
//            this.transaction_name = "";
//            this.remark = "";
//            this.validate_option = true;
//            this.disable_edit_form = true;
//            this.validate_list = result['list'];
//
//            this.sortedData = result['list'];
//            this.sort_table.SetDataArray(
//                result['list'],
//                [{value: "transaction_name", type: ""}, {value: "applicant", type: ""}, {value: "timestamp", type: ""}]
//            );
//            
//            this.complete_infos = false;
//            this.app_component.hide_wrapper(false);
//        });
//    }

    SessionMod(list: any): void {
        this.session_mode = "RECEPTION";
        for (let i = 0; i < list.length; i++) {
            if (list[i].status === "MODIFICATION") {
                this.session_mode = "MODIFICATION";
            }
        }
    }

    GetTransactionDetails_cb(purchase_list: any): void {
        this.validate_list = purchase_list;
        this.activated_route.params.subscribe((params: Params) => {
            let id = params['id_transaction_details'];
            if (id !== undefined) {
                this.AddtoCart(parseInt(id));
            }
        });
    }

    AddArticleInfos(): void {
//        this.transactions_service.AddArticleInfosOs().then(result => {this.SessionModPopup(result['list']); this.TotalArticle(result['list']); this.articles_list_popup = result['list']; this.complete_infos = true; this.app_component.hide_wrapper(true);});
    }

    Cancel(): void {
        this.complete_infos = false;
        this.app_component.hide_wrapper(false);
    }

    session_mode_pop_up: string = "KO";
    SessionModPopup(list: any): void {
        this.session_mode_pop_up = "OK";
        for (let i = 0; i < list.length; i++) {
            if (list[i].serial_status === "KO") {
                this.session_mode_pop_up = "KO";
            }
        }


        //  console.log(this.session_mode);
    }

    total_art: number = 0;
    TotalArticle(list: any): void {
        this.total_art = 0;
        for (let i = 0; i < list.length; i++) {
            this.total_art = this.total_art + parseInt(list[i]['qte_received']);
        }
    }

    EditAndValidateModificationPopup(prod: any): void {
        //console.log(this.src_bt);

        //if (this.src_bt === "../../img/ico_modif.png") {prod.status === "RECEIPTION"
        if (prod.status === "RECEPTION") {
            //console.log(prod.id_article);
            this.EditArticleSessionPopup(prod);
        } else if (prod.status === 'MODIFICATION') {
            this.ValidateEditArticleSessionPopup(prod);
        }
    }

    EditArticleSessionPopup(prod: any): void {
        this.stock_service.EditArticleSessionReceiptOs(prod.index).then(result => {this.articles_list_popup = result['list']; this.SessionModPopup(result['list'])});
    }

    ValidateEditArticleSessionPopup(prod: any): void {
        this.stock_service.ValidateEditArticleSessionIssuePopup(prod).then(result => {this.articles_list_popup = result['list']; this.SessionModPopup(result['list'])});
    }

//    ValidatePop(): void {
//        this.ValidatePannierPurchaseDetail();
//    }
}



// WEBPACK FOOTER //
// ./src/app/out-in-order-from-out-of-ware.component.ts